import { useState } from "react";
import { imgFallback } from "../../../utils/imgFallback";
import styles from "./ProductImage.module.scss";

interface Props {
  src: string;
  alt: string;
  showPlaceholder: boolean;
  config: { placeholder_url?: string | null };
  wrapperClassName?: string;
  loading?: "eager" | "lazy";
  children?: React.ReactNode;
}

export const ProductImage = ({
  src,
  alt,
  showPlaceholder,
  config,
  wrapperClassName = "",
  loading = "lazy",
  children,
}: Props) => {
  const [loaded, setLoaded] = useState(false);

  if (!src && !showPlaceholder) return null;

  return (
    <div className={`${styles.wrapper} ${!loaded ? styles.skeleton : ""} ${wrapperClassName}`}>
      {src && (
        <img
          src={src}
          alt={alt}
          className={`${styles.img} ${loaded ? styles.visible : styles.hidden}`}
          loading={loading}
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={(e) => imgFallback(e, config.placeholder_url)}
        />
      )}
      {children}
    </div>
  );
};
